// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"f40bd2cd38008ef30cff","293":"f39688b0cba3c9db5b55","518":"c47fff192671861b5b30","779":"ed48b6763ac8331589db"}[chunkId] + ".js";
};